import { h } from '@stencil/core';
import dynamicBannerStore from '../../conversational-search-banners/dynamic/dynamic-banner-mediator/dynamic-banner-store';
import { getExternalOriginSessionStorageValue } from '../../conversational-search-logic/storage-manager/storage-manager-helpers';
import type { ConversationalSearchMessagesMediatorsWrapper } from './mediators-wrapper';
import { handleDynamicBannerProcessing, newMessageHandler } from './mediators-wrapper-helpers';

export const renderCorrectMediator = (context: ConversationalSearchMessagesMediatorsWrapper) => {
    if (dynamicBannerStore.get('processed') && context.isPreloadVariant) {
      return (
        <uiaas-search-widget-conversational-search-messages-preload-mediator
          searchQuery={context.searchQuery}
          labelProvider={(e, f) => context.labelProvider(e, f)}
          preloadCallback={() => handleDynamicBannerProcessing(context)}
        />
      );
    }

    if (getExternalOriginSessionStorageValue()) {
      return (
        <uiaas-search-widget-conversational-search-messages-external-origin-mediator
          searchQuery={context.searchQuery}
          labelProvider={(e, f) => context.labelProvider(e, f)}
          country={context.country}
          language={context.language}
          conversationalSearchBrandUrl={context.conversationalSearchBrandUrl}
        />
      );
    }

    return (
      <uiaas-search-widget-conversational-search-messages-initial-mediator
        searchQuery={context.searchQuery}
        labelProvider={(e, f) => context.labelProvider(e, f)}
        acceptanceCallback={() => newMessageHandler(context.searchQuery, context, true)}
      />
    );
};
